import { createApp } from 'vue'
import ArticleCard from '~/js/components/articleCard'
import FTab from '~/js/components/tab'
import { Article, CATEGORIES } from '~/js/models/article'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'

const CLASS_NAME = 'js-indexNews'
const tags = ['ALL', ...CATEGORIES]

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const tabItems = tags.map((tabItem) => {
      return { title: tabItem.toUpperCase(), isSelected: false }
    })

    createApp({
      name: 'TemplatesIndexNews',
      components: {
        ArticleCard,
        FTab,
      },
      data() {
        return {
          articlesMap: {},
          articleItems: [],
          selectedIndex: 0,
          tabItems,
        }
      },
      created() {
        this.setSelectedTabItem()
        this.fetchArticles()
      },
      methods: {
        fetchArticles() {
          const noImageUrl = element.dataset.noImageUrl
          fetch(`${baseUrlFrontApi}/contents/news/sections?limit=4`, {
            method: 'GET',
          })
            .then((response) => response.json())
            .then((data) => {
              for (const tag of Object.keys(data)) {
                const articles = data[tag].map(
                  (article) =>
                    new Article({
                      ...article,
                      published_at: article.publishedAt,
                      image: article.image ? article.image.url : noImageUrl,
                    })
                )
                this.articlesMap[tag] = articles
                // 初期描画時はALLの記事を表示する
                if (tag === 'ALL') this.setArticles()
              }
            })
        },

        onTabItemClicked(index) {
          this.selectedIndex = index
          this.setSelectedTabItem()
          this.setArticles()
        },

        moveToNewsPage(tag) {
          const categoryId = Article.getIdFromTag(tag)
          window.location.href = `/blogs/news?category=${categoryId}`
        },

        setSelectedTabItem() {
          this.tabItems.forEach((item, index) => {
            item.isSelected = index === this.selectedIndex
          })
        },

        setArticles() {
          const tag = tags[this.selectedIndex]
          this.articleItems = this.articlesMap[tag]
        },
      },
    }).mount(element)
  })
})
